function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { useTheme as v } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: o , size: a = 24  } = _param, h = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const e = n(), c = o !== null && o !== void 0 ? o : e ? t.colors.inverse : t.colors.neutralHigh, { skinName: r  } = v();
    return r.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: c,
                d: "M17 7.164h3.214A1.786 1.786 0 0122 8.95v10.893a1.786 1.786 0 01-1.786 1.785h-1.428a.357.357 0 010-.714h1.428a1.072 1.072 0 001.072-1.071v-8.34H4.857a.357.357 0 010-.714h2.5L5.54 8.964a1.164 1.164 0 01-.357-.828c.002-.087.012-.173.032-.258H3.786A1.071 1.071 0 002.714 8.95v10.893a1.072 1.072 0 001.072 1.071H14.5a.357.357 0 110 .714H3.786A1.786 1.786 0 012 19.843V8.95a1.786 1.786 0 011.786-1.786H5.66l4.832-4.821a1.207 1.207 0 011.664 0L17 7.164zm-11.11.972c0 .121.049.238.135.325l2.329 2.314h2.31a1.808 1.808 0 00-2.571-2.543.357.357 0 11-.504-.507 2.521 2.521 0 012.772-.532 1.71 1.71 0 112.885.864 1.692 1.692 0 01-1.178.518c-.12 0-.24-.012-.357-.036.131.312.199.647.2.986a2.5 2.5 0 01-.357 1.264h1.953l-.157-.153a.358.358 0 11.507-.508l.66.665h1.59L14.59 9.278a.358.358 0 11.507-.507l2.011 2.018h2.5l-7.953-7.953a.472.472 0 00-.654 0L6.025 7.807a.471.471 0 00-.136.329zm6.147-.287c.263 0 .515-.1.706-.281a1 1 0 10-1.41 0c.19.18.442.281.704.281zm5.677.03l2.904 2.903.668.007V8.95a1.072 1.072 0 00-1.072-1.07h-2.5z"
            }),
            /* @__PURE__ */ l("path", {
                fill: c,
                d: "M17.396 21.278a.714.714 0 11-1.428 0 .714.714 0 011.428 0z"
            })
        ]
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, h), {
        children: /* @__PURE__ */ l("path", {
            fill: c,
            d: "M21.837 12.953c0-.711-.563-1.291-1.255-1.291v-.003h-.308l-.003-1.723c.036-.725-.163-1.35-.577-1.804a2.104 2.104 0 00-.958-.582V5.917c0-.687-.524-1.25-1.21-1.32V2.99a.43.43 0 00-.132-.308.403.403 0 00-.308-.112l-12.61.891a2.28 2.28 0 00-1.642.7 2.41 2.41 0 00-.678 1.687v13.075c-.04.72.163 1.342.577 1.796.42.456 1.034.711 1.737.717l13.501-.006c1.28 0 2.32-1.07 2.32-2.386l-.003-1.846h.294c.692 0 1.255-.58 1.255-1.292v-2.952zM2.977 5.88v-.033c0-.412.154-.799.44-1.087a1.492 1.492 0 011.086-.451l12.2-.86v1.187l-11.667.838A1.33 1.33 0 003.71 6.807V7.2a1.46 1.46 0 01-.294-.23 1.543 1.543 0 01-.44-1.089zm16.49 13.163c0 .848-.672 1.54-1.496 1.535l-13.498.005c-.474-.005-.877-.165-1.14-.45-.258-.284-.381-.687-.356-1.194V7.684c.417.37.938.58 1.496.58v.008l13.495-.005c.474.005.86.157 1.12.442.261.283.382.69.357 1.205l.002 1.745h-7.002c-1.429 0-2.589 1.193-2.589 2.66v.22c0 1.464 1.163 2.658 2.589 2.658h7.02l.002 1.846zm1.115-2.69h-8.137c-.975 0-1.765-.812-1.765-1.812v-.218c0-1.003.793-1.815 1.765-1.815h8.134a.44.44 0 01.434.445v2.952a.443.443 0 01-.431.449zM17.91 5.918v1.51L4.53 7.42v-.617c0-.268.227-.49.533-.49L17.11 5.45h.003l.291-.023a.5.5 0 01.505.49zm-5.27 9.327a.806.806 0 01-.792-.815c0-.448.356-.815.793-.815.437 0 .792.364.792.815a.803.803 0 01-.792.815zm1.614-.815c0-.916-.723-1.66-1.613-1.66-.891 0-1.617.744-1.617 1.66 0 .916.726 1.661 1.617 1.661.888 0 1.613-.745 1.613-1.66z"
        })
    }));
}, d = s;
export { d as default };
